package com.milta.core.localization.translations.sq

import com.milta.core.localization.OptimizationQuotaStrings

internal val OptimizationQuota = OptimizationQuotaStrings(
    exhaustedTitle = "Kuota e optimizimeve u arrit",
    exhaustedCreateRouteMessage = "Sërish më {date}. Mund ta krijoni itinerarin pa optimizim: renditja e futur ruhet.",
    exhaustedCreateBatchMessage = "Sërish {limit} optimizime më {date}. Grupi mund të krijohet pa optimizim: renditja e futur ruhet.",
    quotaReachedResetOn = "Kuota e optimizimeve u arrit — rivendosje më {date}",
    routeCreatedInEnteredOrder = "Itinerari u krijua sipas renditjes së futur.",
    routeWillBeCreatedInEnteredOrder = "Itinerari do të krijohet sipas renditjes së futur.",
    batchCreatedInEnteredOrder = "Grupi u krijua pa optimizim, sipas renditjes së futur.",
    sendWithoutOptimization = "Dërgo pa optimizim",
    batchNotOptimizedTitle = "Grup i krijuar pa optimizim",
    batchNotOptimizedMessage = "Kuota e optimizimeve u arrit. Renditja aktuale e ndalesave ruhet.",
    batchNotOptimizedMobileMessage = "Grup i krijuar pa optimizim: kuota e optimizimeve u arrit. Renditja e futur u ruajt, ndalesat u ndanë në mënyrë të barabartë.",
    reoptimizeAction = "Ri-optimizo",
    reoptimizeUnavailableWeb = "Ri-optimizimi nuk është i disponueshëm: kuota u arrit, sërish më {date}. Renditja aktuale ruhet dhe dërgimi mbetet i mundur.",
    reoptimizeUnavailableMobile = "Ri-optimizimi nuk është i disponueshëm deri më {date} (kuota u arrit). Dërgimi mbetet i mundur.",
    stopAddedAtEndTitle = "Ndalesa u shtua në fund të itinerarit",
    stopAddedAtEndMessage = "Kuota e optimizimeve u arrit — rivendosje më {date}. Renditja e ndalesave të tjera nuk ndryshon.",
    reoptimizeExhaustedHint = "Kuota e optimizimeve u arrit, sërish më {date}",
    myOptimizationsTitle = "Optimizimet e mia",
    remainingForPeriod = "Të mbetura për periudhën",
    remainingSuffix = "të mbetura",
    resetLabel = "Rivendosje",
    resetAtRenewal = "Në rinovimin e abonimit",
    driverExplanation = "Rivendoset në rinovimin e abonimit tuaj. Shofer i një Ndërmarrjeje: numëruesi juaj ndjek abonimin e Ndërmarrjes, me kufirin provë sa kohë ajo është në provë.",
    enterpriseExplanation = "Rivendoset në rinovimin e abonimit tuaj. Ky numërues mbulon vetëm optimizimet tuaja; çdo shofer ka të vetin.",
    webCounterNotice = "Ky numërues mbulon vetëm optimizimet e nisura nga kjo llogari. Çdo shofer ka të vetin, të dukshëm në aplikacionin e tij.",
    historyTitle = "Historiku",
    columnDate = "Data",
    columnAction = "Veprimi",
    columnTarget = "Itinerari përkatës",
    columnOutcome = "Rezultati",
    actionOptimizeRoute = "Optimizim itinerari",
    actionCreateRouteBatch = "Krijim grupi",
    actionReoptimizeRouteBatch = "Ri-optimizim grupi",
    actionReoptimizeOnStopAdded = "Ri-optimizim pas shtimit të një ndalese",
    actionReoptimizeInPlace = "Ri-optimizim gjatë rrugës",
    actionCreateOwnRoute = "Krijim i itinerarit tim",
    outcomeCounted = "E numëruar",
    outcomeRefunded = "E kthyer",
    outcomeRefundedLong = "E kthyer — gabim RoutaR",
    refundedNotCounted = "gabim RoutaR, e panumëruar",
    targetRoute = "Itinerari i {date}",
    targetBatch = "Grupi i {date}",
    historyLoadingMore = "Po ngarkohen rreshtat e radhës…",
    historyEnd = "Fundi i historikut — {count} rreshta",
    historyEmpty = "Asnjë optimizim në këtë periudhë.",
    historyLoadError = "Historiku nuk mund të ngarkohej.",
    retryAction = "Provo sërish",
    loading = "Duke u ngarkuar…",
    errorNoConnection = "Serveri nuk mund të kontaktohet — kontrolloni lidhjen.",
    errorGeneric = "Ndodhi një gabim. Provoni më vonë.",
    tabOptimizations = "Optimizimet RoutaR",
    tabAiTokens = "Tokenët IA",
    comingSoon = "Së shpejti",
    limitsDescription = "Numri i optimizimeve RoutaR të lejuara për llogari dhe për periudhë abonimi, sipas llojit të llogarisë dhe statusit të abonimit. Numëruesi i çdo llogarie rivendoset në rinovimin e abonimit të saj.",
    columnTrial = "Provë",
    columnPaid = "Me pagesë",
    rowEnterprise = "Llogari Ndërmarrjeje",
    rowDriver = "Shofer",
    fieldRequired = "Fushë e detyrueshme.",
    fieldMustBePositive = "Duhet të jetë më e madhe se 0.",
    limitsFootnote = "Vlera në optimizime për periudhë. Një shofer i një Ndërmarrjeje merr kufirin «Shofer», provë sa kohë Ndërmarrja e tij është në provë, përndryshe me pagesë.",
    limitsSaved = "Kufijtë u ruajtën. Ndërmarrje: {enterpriseTrial} provë · {enterprisePaid} me pagesë. Shofer: {driverTrial} provë · {driverPaid} me pagesë.",
    limitsRejected = "Vlerat u refuzuan: çdo kufi duhet të jetë më i madh se 0.",
    saveAction = "Ruaj",
    detailsAction = "Detaje",
    accountDetailsTitle = "Detajet e përdoruesit",
    sectionIdentity = "Identiteti",
    accountTypeLabel = "Lloji i llogarisë",
    kindEnterpriseOwner = "Llogari Ndërmarrjeje",
    kindEnterpriseDriver = "Shofer i Ndërmarrjes",
    kindIndependentDriver = "Shofer i pavarur",
    withoutOrganisation = "Pa organizatë",
    subscriptionLabel = "Abonimi",
    viaOrganisation = "Përmes organizatës",
    subscriptionTrial = "Provë",
    subscriptionPaid = "Me pagesë",
    appliedLimitLabel = "Kufiri i zbatuar",
    limitKindEnterprise = "Kufiri Llogari Ndërmarrjeje",
    limitKindDriver = "Kufiri Shofer",
    enterpriseInTrialSuffix = "(Ndërmarrja është në provë)",
    resetSourceOwn = "Rinovimi i abonimit",
    resetSourceEnterprise = "Rinovimi i {enterprise}",
    exhaustedBadge = "Kuota u shter",
    manuallyAdjustedBadge = "Zëvendësuar manualisht",
    replaceLabel = "Zëvendëso numrin e mbetur",
    replaceAction = "Zëvendëso",
    replaceHelp = "Vetëm për periudhën aktuale. Në rivendosje, llogaria rinis nga kufiri global.",
    replaceHelpEnterpriseDriver = "Ndryshon vetëm numëruesin e {name}. Ai i Ndërmarrjes dhe i shoferëve të tjerë nuk ndryshon.",
    replaceInvalid = "Futni një numër më të madh ose të barabartë me 0.",
    replaceRejected = "Vlera u refuzua nga serveri.",
    replaceMaximum = "Maksimumi 100 000.",
    replacedBanner = "Numri i mbetur u zëvendësua: {from} → {to}. Për periudhën aktuale. Më {date}, kthim te kufiri global ({limit}).",
    adminHistoryTitle = "Historiku i optimizimeve",
    accountNotFound = "Llogaria nuk u gjet.",
)
